export default class VttFooter {
    public id: string;
    public logoImage: string;
    public content: string;
    
    constructor() {
      this.id = "";
      this.logoImage = "";
      this.content = "";
    }
}


// WEBPACK FOOTER //
// ./src/api/footerEntity.ts